// extracted by mini-css-extract-plugin
export var downArrow = "_8t-0";
export var label = "_8t-1";
export var treatmentCard = "_8t-3";
export var upArrow = "_8t-2";